import React from "react";

function AboutTugba(): JSX.Element {
    return (
        <section className="w-full py-16" style={{ backgroundColor: "#E6E6FA" }} >
            <div className="container mx-auto flex flex-col md:flex-row items-start gap-10 px-6 md:px-12 lg:px-20">
                
                {/* Text Content */}
                <div className="md:w-2/3 w-full text-gray-800 space-y-6">
                    <h1 className="text-4xl font-bold text-blue-900 mb-4">About Me – Tuba</h1>

                    <p>
                        Hello, and welcome! My name is Tuba, and I’m the founder of <strong>The One Childcare</strong> – a home nursery built on care, trust, and a lifelong love of working with children.
                    </p>
                    <p>
                        I originally come from Turkey, where my passion for education and child development began at an early age. From as young as 14, I chose to attend a high school with a <strong>pedagogical focus</strong>, where my studies were centered around teaching methods, classroom psychology, and early childhood development. This early immersion in educational practice inspired me to pursue teaching professionally.
                    </p>
                    <p>
                        After high school, I was proud to continue my journey at <strong>Gazi University</strong>, Turkey’s most prestigious university for teacher education. There, I earned my <strong>degree in Teaching</strong>, developing a strong foundation in child-centered education, language acquisition, and classroom leadership. 
                    </p>
                    <p>
                        For several years, I worked as an <strong>English as a Foreign Language teacher</strong>, teaching children between the ages of <strong>9 and 17</strong>. This role gave me a deep understanding of children’s developmental stages and helped me create engaging and supportive learning environments.
                    </p>
                    <p>
                        Since moving to the <strong>United Kingdom</strong>, I’ve gained hands-on experience in local nurseries, familiarising myself with the <strong>Early Years Foundation Stage (EYFS)</strong> and childcare expectations in the UK. This led me to open my own home nursery where children feel truly valued and cared for.
                    </p>
                    <p>
                        At <strong>The One Childcare</strong>, I blend my international teaching experience with a UK nursery approach to create a nurturing, playful, and safe environment where children can grow and thrive.
                    </p>
                    <p>
                        Thank you for taking the time to learn a little more about me. If you have any questions or would like to arrange a visit, I would love to hear from you!
                    </p>

                    <p className="font-semibold">Warm wishes,<br/>Tuba</p>
                </div>

                {/* Image Content */}
                <div className="md:w-1/3 w-full flex justify-center md:justify-end">
                    <img
                        src="/profile-tugba.jpg"
                        alt="Tuba smiling"
                        className="rounded-xl shadow-lg object-cover max-h-[500px] w-full md:max-w-xs"
                    />
                </div>
            </div>
        </section>
    );
}

export default AboutTugba;
